/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {createRoot} from 'react-dom/client';

import {ImmersiveOnboarding} from './immersive-onboarding';

export const initImmersiveOnboarding = () => {
  const modalsNode = document.getElementById(`modals`);
  const immersiveRoot = document.createElement(`div`);
  modalsNode?.appendChild(immersiveRoot);

  const root = createRoot(immersiveRoot);
  root.render(<ImmersiveOnboarding />);
};
